import { render } from "./HeroiconsOutlineSparkles.vue?vue&type=template&id=7094f7d4"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSparkles.vue"]])

export default __exports__